import PropTypes from "prop-types"
import React, { Component } from "react"
import { getStyles } from "../../styles/dynamicStyles"
import { Link } from "react-router"
import { encodeBreadcrumbsParameters } from "../../routes"
import { dispatch } from "../../Dispatcher"
import api from "../../api"

export default class BreadcrumbsDropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDropdown: false,
      searchInput: "",
      valid_breadcrumbs_options: {}
    }
  }

  dropdownRef
  searchInputRef

  componentDidMount() {
    document.addEventListener("mousedown", this._handleClickOutside)

    // Get the breadcrumbs options for the current subfield
    const { filterName, subfields, subfieldIndex } = this.props
    if (subfieldIndex > 0) {
      const params = new URLSearchParams({
        field_name: filterName
      })

      if (subfields.length) {
        subfields
          .slice(0, subfieldIndex)
          .forEach(subfield => params.append("items_keys[]", subfield.value))
      }

      api("GET", "info/breadcrumbs_options?" + params.toString()).then(data => {
        this.setState({
          valid_breadcrumbs_options: data.valid_breadcrumbs_options || []
        })
      })
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this._handleClickOutside)
  }

  _createBreadcrumbsSearch = (key, title) => {
    const { filterName, subfields, subfieldIndex } = this.props
    const newSubfield = {}

    if (key && title) {
      newSubfield.key = key
      newSubfield.title = title
    }

    const isNewSubfieldEmpty = Object.keys(newSubfield).length === 0

    return encodeBreadcrumbsParameters(
      filterName,
      subfieldIndex > 0
        ? isNewSubfieldEmpty
          ? [
              ...subfields
                .map(subfield => {
                  return {
                    key: subfield.value,
                    title: subfield.title
                  }
                })
                .slice(0, subfieldIndex)
            ]
          : [
              ...subfields
                .map(subfield => {
                  return {
                    key: subfield.value,
                    title: subfield.title
                  }
                })
                .toSpliced(subfieldIndex, 1, newSubfield)
            ]
        : [newSubfield]
    )
  }

  _handleRemoveSubfields = () => {
    const { filterName, subfieldIndex, removeSubfield } = this.props

    this.setState({
      searchInput: "",
      showDropdown: false
    })

    removeSubfield(subfieldIndex)

    if (subfieldIndex > 0) {
      dispatch({
        type: "set-breadcrumbs-term",
        name: filterName,
        breadcrumbsSearch: decodeURIComponent(this._createBreadcrumbsSearch())
      })
    } else {
      dispatch({
        type: "clear-breadcrumbs-term",
        name: filterName
      })
    }
  }

  _handleUpdateSubfields = (value, title) => {
    const { filterName, subfieldIndex, updateSubfields } = this.props

    this.setState({
      searchInput: "",
      showDropdown: false
    })

    updateSubfields({
      index: subfieldIndex,
      value,
      title
    })
    dispatch({
      type: "set-breadcrumbs-term",
      name: filterName,
      breadcrumbsSearch: decodeURIComponent(
        this._createBreadcrumbsSearch(value, title)
      )
    })
  }

  _handleClickOutside = ({ target }) => {
    if (this.dropdownRef && !this.dropdownRef.contains(target)) {
      this.setState({
        searchInput: "",
        showDropdown: false
      })
    }
  }

  _toggleDropdown = () => {
    this.setState({
      searchInput: "",
      showDropdown: !this.state.showDropdown
    })
  }

  render() {
    const {
      filterName,
      breadcrumbOptions,
      enableSearch,
      selectedType
    } = this.props
    const { valid_breadcrumbs_options } = this.state
    const options = breadcrumbOptions || valid_breadcrumbs_options

    if (Object.keys(options).length) {
      return (
        <div ref={e => (this.dropdownRef = e)}>
          <div
            className="field collect-filter-field"
            style={getStyles(["field", "collect-filter-field"])}
          >
            <div className="field-body" style={getStyles("field-body")}>
              <div
                className="breadcrumbs-input"
                style={getStyles("breadcrumbs-input")}
              >
                <div
                  className="dropdown click-toggle"
                  style={getStyles(["dropdown", "click-toggle"])}
                >
                  <div
                    className="dropdown-trigger"
                    style={getStyles("dropdown-trigger")}
                    onClick={this._toggleDropdown}
                  >
                    <div
                      className="dropdown-input"
                      style={getStyles("dropdown-input")}
                      aria-haspopup="true"
                      aria-controls="dropdown-menu"
                    >
                      {selectedType ? (
                        <span>
                          {selectedType.title && selectedType.title.length > 20
                            ? `${selectedType.title.slice(0, 20)}...`
                            : selectedType.title}
                        </span>
                      ) : (
                        <span
                          className="placeholder"
                          style={getStyles("placeholder")}
                        >
                          Select Item
                        </span>
                      )}

                      {selectedType && (
                        <button
                          type="button"
                          className="badge__close"
                          style={getStyles("badge__close")}
                          onClick={e => {
                            e.stopPropagation()
                            this._handleRemoveSubfields()
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.state.showDropdown && (
            <div
              className="dropdown-menu"
              style={getStyles("dropdown-menu")}
              id="dropdown-menu"
              role="menu"
            >
              <div
                className="dropdown-content"
                style={getStyles("dropdown-content")}
              >
                {enableSearch &&
                  Object.keys(options).length > 5 && (
                    <div
                      className="dropdown-search"
                      style={getStyles("dropdown-search")}
                    >
                      <input
                        className="input"
                        style={getStyles("input")}
                        placeholder="Search"
                        value={this.searchInput}
                        onChange={this.searchInput.onChange}
                        ref={e => this.searchInputRef(e)}
                      />
                      <i className="fal fa-search" />
                    </div>
                  )}

                {Object.keys(options).map(id => (
                  <div
                    key={id}
                    className="dropdown-item-wrap"
                    style={getStyles("dropdown-item-wrap")}
                    onClick={() => this._handleUpdateSubfields(id, options[id])}
                  >
                    <Link
                      className="dropdown-item"
                      style={getStyles("dropdown-item")}
                      to={`/search?${filterName}=${this._createBreadcrumbsSearch(
                        id,
                        options[id]
                      )}`}
                    >
                      <span>
                        {options[id].length > 20
                          ? `${options[id].slice(0, 20)}...`
                          : options[id]}
                      </span>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )
    }

    return null
  }
}

BreadcrumbsDropdown.propTypes = {
  breadcrumbOptions: PropTypes.object,
  enableSearch: PropTypes.bool,
  selectedType: PropTypes.object,
  filterName: PropTypes.string,
  subfieldIndex: PropTypes.number,
  subfields: PropTypes.array,
  updateSubfields: PropTypes.func.isRequired,
  removeSubfield: PropTypes.func.isRequired
}

BreadcrumbsDropdown.defaultProps = {
  enableSearch: false
}



// WEBPACK FOOTER //
// ./webapp/components/elements/BreadcrumbsDropdown.js